import { render, staticRenderFns } from "./affairsList.vue?vue&type=template&id=73fa8155&scoped=true&"
import script from "./affairsList.vue?vue&type=script&lang=js&"
export * from "./affairsList.vue?vue&type=script&lang=js&"
import style0 from "./affairsList.vue?vue&type=style&index=0&id=73fa8155&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fa8155",
  null
  
)

export default component.exports